import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "@/lib/constants";

const SPANS = {
  "1-2-1": "md:col-span-12 lg:col-span-7 lg:row-span-2",
  "2-2-1": "md:col-span-6 lg:col-span-5",
  group: "md:col-span-6 lg:col-span-5",
  nutrition: "md:col-span-6 lg:col-span-4",
  senior: "md:col-span-6 lg:col-span-4",
  kids: "md:col-span-12 lg:col-span-4",
};

export const Services = () => {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32 bg-[#09090B] border-t border-zinc-800"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="h-[2px] w-12 bg-[#D4AF37]" />
              <p className="font-display text-[#D4AF37] text-sm font-bold tracking-[0.3em] uppercase">
                Services
              </p>
            </div>
            <h2
              data-testid="services-heading"
              className="font-display text-white font-black uppercase tracking-tight leading-[0.9] text-5xl sm:text-6xl lg:text-7xl max-w-3xl"
            >
              Coaching for <span className="text-[#D4AF37]">every</span> body.
            </h2>
          </div>
          <p className="max-w-sm text-zinc-400 text-base leading-relaxed font-light">
            Six specialised services — private coaching, partner training,
            small groups, nutrition, senior rehabilitation and kids sessions.
            Contact for pricing.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-12 gap-4 lg:gap-5 stagger">
          {SERVICES.map((s, idx) => {
            const big = s.id === "1-2-1";
            return (
              <a
                key={s.id}
                href="#contact"
                data-testid={`service-card-${s.id}`}
                className={`group relative flex flex-col justify-between bg-zinc-900/50 backdrop-blur-sm border border-zinc-800 hover:border-[#D4AF37]/50 transition-all duration-300 hover:-translate-y-1 p-8 ${
                  big ? "lg:p-12" : "lg:p-9"
                } ${SPANS[s.id]}`}
              >
                <div>
                  <div className="flex items-start justify-between mb-8">
                    <span
                      className={`font-display font-black tracking-tight text-zinc-700 group-hover:text-[#D4AF37]/60 transition-colors duration-300 ${
                        big ? "text-6xl lg:text-8xl" : "text-4xl lg:text-5xl"
                      }`}
                    >
                      {String(idx + 1).padStart(2, "0")}
                    </span>
                    <ArrowUpRight
                      size={22}
                      strokeWidth={1.5}
                      className="text-zinc-600 group-hover:text-[#D4AF37] group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300"
                    />
                  </div>

                  <p className="font-display text-[#D4AF37] text-xs font-bold tracking-[0.3em] uppercase mb-2">
                    {s.short}
                  </p>
                  <h3
                    className={`font-display text-white font-bold uppercase tracking-tight leading-none ${
                      big ? "text-4xl lg:text-6xl" : "text-3xl lg:text-4xl"
                    }`}
                  >
                    {s.title}
                  </h3>
                  <p
                    className={`mt-4 text-zinc-400 leading-relaxed font-light ${
                      big ? "text-base lg:text-lg max-w-lg" : "text-sm"
                    }`}
                  >
                    {s.description}
                  </p>
                </div>

                <div className="mt-8 pt-6 border-t border-zinc-800 flex flex-wrap gap-2">
                  {s.highlights.map((h) => (
                    <span
                      key={h}
                      className="text-[10px] font-medium tracking-[0.14em] uppercase text-zinc-500 border border-zinc-800 px-2.5 py-1"
                    >
                      {h}
                    </span>
                  ))}
                </div>
              </a>
            );
          })}
        </div>

        <div className="mt-16 flex flex-col items-center gap-5">
          <p className="text-zinc-500 text-sm font-light">
            Contact for pricing &amp; availability
          </p>
          <a
            href="#contact"
            data-testid="services-contact-link"
            className="group inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#F3CE56] text-zinc-950 px-9 py-4 font-display text-base font-bold uppercase tracking-[0.16em] transition-colors duration-300"
          >
            Enquire For Pricing
            <ArrowUpRight
              size={18}
              strokeWidth={2}
              className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
            />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Services;
